import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from "@angular/router";
import { ModalDirective } from "ng2-bootstrap";
import { Subscription } from 'rxjs';

import { Event,EventId } from "app/models/base/event";
import { WebMethodResult } from "../../../models/web-method-result";


import { SecurityService } from '../../../services/settings/security.service';
import { ClientSettingsService } from '../../../services/settings/client-settings.service';
import { BaseComponent } from '../../base/base.component';
import { AppModulePath } from '../../../models/app-module-path';

@Component({
  selector: 'app-home-osnovna-sredstva',
  templateUrl: './home-osnovna-sredstva.component.html',
  styleUrls: ['./home-osnovna-sredstva.component.scss']
})
export class HomeOsnovnaSredstvaComponent extends BaseComponent implements OnInit {

  private afterLogin: boolean;
    protected username;
    protected activeUserId;
    protected activeCompany;
    protected activeStockroom;
    @ViewChild('chooseCSDialog', {static: false})
    private chooseCSDialog: ModalDirective;
    protected showCalendar:boolean;
    protected appModulePath;
    changeActiveStockroomSubscription: Subscription;
  constructor(private clientSettings: ClientSettingsService,
    public securityService: SecurityService,
    public router: Router,
    private location: Location) {
      super();
        this.appModulePath = AppModulePath;
        this.showCalendar = true;
        router.events.subscribe((val) => {
            //console.log(location.path());
            if(location.path() != '/ng/osnovna-sredstva'){
              this.showCalendar = false;
            } else {
                this.showCalendar = true;
            }
          });

    }

  ngOnInit() {
    this.changeActiveStockroomSubscription = this.clientSettings.onChangeActiveStockroom.subscribe(
      () => {
          this.activeStockroom = this.clientSettings.getActiveStockroom();
          this.clientSettings.setActiveStockroom( this.activeStockroom );
      }
    );

      this.securityService.fetchLoggerUser().subscribe(
              data => {
                  this.username = this.securityService.loggedUser.fullName();
                  this.activeUserId = this.securityService.loggedUser.id;
                  this.activeCompany = this.clientSettings.getActiveCompany();
                  this.activeStockroom = this.clientSettings.getActiveStockroom();

                  if ((this.activeCompany != null && this.activeCompany.id == null) ||
                          (this.activeStockroom != null && this.activeStockroom.id == null)) {
                      this.afterLogin = true;
                      if(this.chooseCSDialog != undefined) this.chooseCSDialog.show();
                  }
                  else {
                      this.clientSettings.setActiveCompany(this.activeCompany);
                      this.clientSettings.setActiveStockroom(this.activeStockroom);
                  }
              });
  }

  onLogout(){
    this.securityService.logout().subscribe(
            success => window.location.reload()
          );
}
showChooseCSDialog(){
    this.afterLogin = false;
    this.chooseCSDialog.show();
}
onEvent(event: Event) {
    if (event.id === EventId.DIALOG_OK) {
      this.activeCompany = event.object.company;
      this.activeStockroom = event.object.stockroom;

      this.clientSettings.setActiveCompany(this.activeCompany);
      this.clientSettings.setActiveStockroom(this.activeStockroom);

      if (this.afterLogin) {
        this.router.navigate(['ng/home']);
      }
    } else if (event.id === EventId.DIALOG_CANCEL && this.afterLogin) {
      this.displayErrorPage('Niste izabrali ni kompaniju ni magacin!');
      // this.router.navigate(['ng/error'], {
      //   queryParams: {
      //     errorObj: JSON.stringify(WebMethodResult.create(-1, 'Niste izabrali ni kompaniju ni magacin!'))
      //   }
      // });
    }
    this.chooseCSDialog.hide();
}

}
